import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { ArrowDown2 } from 'iconsax-react';

import { DynamicCustomFieldFilterDropdown } from './dynamic-custom-field-filter-dropdown';
import { DynamicCustomFieldFilter } from './dynamic-custom-field-filter';
import { DynamicCustomFieldOperatorDropdown } from './dynamic-custom-field-operator-dropdown';

import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import { cn } from '@src/design-system/helpers';
import { inputVariants } from '@src/design-system/input';

import { DynamicCustomFieldFilterDeleteBtn } from './dynamic-custom-field-filter-delete-btn';

import type { TCustomFieldFilter } from '@shared/types/custom-field-filter';

export function DynamicCustomFieldFilterRow({
  position,
  dynamicFilter,
}: {
  dynamicFilter: TCustomFieldFilter;
  position: number;
}) {
  const { updateCustomFieldFilter } = useTableViewHelpers();

  return (
    <div className='grid grid-cols-[150px_80px_200px_max-content] items-center gap-2'>
      <DropdownMenu>
        <DropdownMenuTrigger
          className={cn(
            'text-sm relative cursor-pointer items-center',
            inputVariants({ size: 'sm' })
          )}
        >
          <span className='w-[90%] text-start truncate'>
            {dynamicFilter.custom_field?.label
              ? dynamicFilter.custom_field?.label
              : 'Select'}
          </span>
          <ArrowDown2
            size={16}
            className='text-primary-1000 absolute right-2 top-1/2 -translate-y-1/2'
          />
        </DropdownMenuTrigger>

        <DropdownMenuContent
          align='start'
          isInModal
          className='p-2 h-[250px]'
        >
          <DynamicCustomFieldFilterDropdown index={position} />
        </DropdownMenuContent>
      </DropdownMenu>

      {dynamicFilter.custom_field && dynamicFilter.operator && (
        <DynamicCustomFieldOperatorDropdown
          dynamicField={dynamicFilter}
          onChange={(op) =>
            updateCustomFieldFilter(
              {
                operator: op,
              },
              position
            )
          }
          currentOperator={dynamicFilter.operator}
          questionType={dynamicFilter.custom_field.type}
        />
      )}

      {dynamicFilter.custom_field && (
        <DynamicCustomFieldFilter
          dynamicField={dynamicFilter}
          index={position}
        />
      )}

      <DynamicCustomFieldFilterDeleteBtn position={position} />
    </div>
  );
}
